<button
  type="button"
  aria-label="Fermer le formulaire"
  class="btn-clean cej-modal__close-btn"
  (click)="closeDialog('', false)"
>
  <mat-icon svgIcon="cross"></mat-icon>
</button>
<div class="cej-modal">
  <img
    [src]="illustrationMobileSrc | imaginarySrc: 1:500"
    [srcset]="illustrationMobileSrc | imaginarySrc: 4:500"
    class="cej-modal__illustration-mobile"
    alt=""
    loading="lazy"
  />
  <section class="cej-modal__content">
    <h2 class="cej-modal__title">Je découvre dès maintenant le Contrat d&apos;Engagement Jeune&nbsp;!</h2>
    <p class="cej-modal__subtitle">
      Un parcours personnalisé pour m&apos;aider à définir mon projet professionnel et trouver un emploi.
    </p>
    <h3 class="cej-modal__list-title">Qu&apos;est-ce que le Contrat d&apos;Engagement Jeune&nbsp;?</h3>
    <ul class="cej-modal__list">
      <li class="cej-modal__list__item">
        <h4>Un suivi personnalisé</h4>
        <p>Pendant plusieurs mois, vous êtes accompagnés de 15 à 20 heures par semaine minimum.</p>
      </li>
      <li class="cej-modal__list__item">
        <h4>Un référent unique</h4>
        <p>Un conseiller vous accompagne tout au long de votre parcours.</p>
      </li>
      <li class="cej-modal__list__item">
        <h4>Une allocation financière</h4>
        <p>Une allocation pouvant aller jusqu&apos;à 500 euros par mois si vous en avez besoin.</p>
      </li>
    </ul>
    <div #modalActions class="cej-modal__actions">
      <a
        class="btn-clean btn cej-modal__actions__btn"
        [class.cej-modal__actions__btn--fixed]="(modalActionsVisible$ | async) === false"
        [routerLink]="['/', FeaturesRoutingEnum.CEJ]"
        (click)="closeDialog('Click Je me lance', true)"
      >
        Je me lance
        <mat-icon class="cej-modal__actions__icon" svgIcon="arrow_next" aria-hidden="true"></mat-icon>
      </a>
      <div
        class="cej-modal-toggle"
        [class.cej-modal-toggle--margin-top]="(modalActionsVisible$ | async) === false"
        [attr.checked]="hideModalControl"
      >
        <button
          type="button"
          class="cej-modal-toggle__button"
          id="cej-modal-toggle-btn"
          role="button"
          [attr.aria-checked]="hideModalControl"
          aria-describedby="cej-modal-toggle-label"
          (click)="switch()"
        >
          <span class="visually-hidden">
            <ng-container *ngIf="!hideModalControl">Activer</ng-container>
            <ng-container *ngIf="hideModalControl">Désactiver</ng-container>
          </span>
        </button>
        <label id="cej-modal-toggle-label" for="cej-modal-toggle-btn" class="cej-modal-toggle__label">
          Ne plus voir ce message
        </label>
      </div>
    </div>
  </section>
  <img
    [src]="illustrationSrc | imaginarySrc: 1:315"
    [srcset]="illustrationSrc | imaginarySrc: 4:315"
    class="cej-modal__illustration"
    alt=""
    loading="lazy"
  />
</div>
